import React from "react";
import { useLang } from "../contexts/LanguageContext";

// Square monogram logos (used in admin / login splash)
const LOGO_TR = "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/uzcbi8u4_t%C3%BCrk%C3%A7e%20logo.PNG";
const LOGO_EN = "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/pq5h6u3u_ingilizce%20logo.PNG";

// Wide banner logos (navbar). Different intrinsic aspect ratios:
//   TR ≈ 5.10  (taller)   ->   needs slightly taller height to match EN's rendered width
//   EN ≈ 5.92  (wider)
// We size each so that both render at the SAME visible width (~445px / lg ~568px).
const BANNER_TR = "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/9ah4fn75_banner%20logo%20t%C3%BCrk%C3%A7e.PNG";
const BANNER_EN = "https://customer-assets.emergentagent.com/job_alaca-partners/artifacts/gbnudgum_banner%20logo%20ingilizce.PNG";

export const Wordmark = ({ className = "" }) => {
  const { lang } = useLang();
  const src = lang === "en" ? BANNER_EN : BANNER_TR;
  // EN baseline: h-20 lg:h-24 → 80px / 96px
  // TR slightly taller to compensate for its narrower aspect ratio
  const sizeClass = lang === "en"
    ? "h-20 lg:h-24"
    : "h-[92px] lg:h-[112px]";
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={src}
        alt="Alaca Partners"
        className={`${sizeClass} w-auto select-none object-contain`}
        draggable="false"
      />
    </div>
  );
};

export const LogoMark = ({ className = "" }) => {
  const { lang } = useLang();
  return (
    <img
      src={lang === "en" ? LOGO_EN : LOGO_TR}
      alt="Alaca Partners"
      className={`object-contain ${className}`}
      draggable="false"
    />
  );
};
